<template>
    <div class="columns">
        <div class="column is-6 is-offset-3">
            <div class="box">
                <form @submit.prevent="resetPassword">
                    <form-input v-model="user.email" type="email" label="Correo electrónico" holder="Correo electrónico" :error="errors.email"></form-input>
                    <form-input v-model="user.password" type="password" label="Contraseña" holder="Contraseña" :error="errors.password" reveal></form-input>
                    <form-input v-model="user.password_confirmation" type="password" label="Confirmar contraseña" holder="Confirmar contraseña" reveal minlength="6" :error="errors.password_confirmation"></form-input>
                    <div class="field">
                        <p class="control">
                            <button type="submit" class="button is-primary is-fullwidth">
                                Restablecer contraseña
                            </button>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PasswordReset",
        data() {
            return {
                user: {},
                errors: {},
            }
        },
        props: {
            token: String
        },
        methods: {
            resetPassword() {
                this.errors = {};
                this.$loader.show();
                this.user.token = this.token || '';
                this.$http.post('password/reset', this.user)
                    .then(({data}) => {
                        this.$loader.hide();
                        this.$notify.success(data.message);
                        this.$auth.login({
                            data: this.user
                        })
                    }, ({response}) => {
                        this.$loader.hide();
                        let data = response.data;
                        this.$notify.danger(data.message);
                        this.errors = data.errors || {};
                    })
            }
        }
    }
</script>

<style scoped>

</style>
